import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const internalCultureRoutes = [
  {
    page: MainPage,
    path: pathRoutes.internalCulture,
    screenCode: SCREEN.IP_007,
  },
];
